export default "__VITE_ASSET__$IVt1axC__"